import { ApplicationType } from '@wix/editor-application';

export enum EnvType {
  Worker = 'WORKER',
  Frame = 'FRAME',
}

export type IApiHostConfig = {
  type: ApplicationType;
  env: EnvType;
};

export type IApiConfigChecker = (config: IApiHostConfig) => boolean;

export const classMetadataKey = Symbol('CLASS_METADATA_KEY');
